import color from "constants/color";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 136px 32px 32px 32px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
`;

export const Card = styled.div`
  flex-shrink: 1;
  position: relative;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: ${color.Black};
  margin: 0;
`;

export const IframeContainer = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;
